import { buildGlobalReferenceContext } from '../../../../context/buildGlobalReferenceContext.mjs';

const [SingleSelectContextProvider, useSingleSelectContext] = buildGlobalReferenceContext("SingleSelect");

export { SingleSelectContextProvider, useSingleSelectContext };
//# sourceMappingURL=context.mjs.map
